/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LegalAgreementType = {
    UmbrellaCommercialContract: 'UMBRELLA_COMMERCIAL_CONTRACT'
} as const;
export type LegalAgreementType = typeof LegalAgreementType[keyof typeof LegalAgreementType];


export function instanceOfLegalAgreementType(value: any): boolean {
    for (const key in LegalAgreementType) {
        if (Object.prototype.hasOwnProperty.call(LegalAgreementType, key)) {
            // @ts-ignore
            if (LegalAgreementType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LegalAgreementTypeFromJSON(json: any): LegalAgreementType {
    return LegalAgreementTypeFromJSONTyped(json, false);
}

export function LegalAgreementTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAgreementType {
    return json as LegalAgreementType;
}

export function LegalAgreementTypeToJSON(value?: LegalAgreementType | null): any {
    return value as any;
}

